import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { Router, browserHistory } from 'react-router'

import { setLocation } from '../../reducers/location'
import { requestWpPageDataSuccess } from '../../reducers/wpData'

import { getWpPageData } from '../../utils/wordpress'

import routes from '../routes/'

const Root = class Root extends Component {
  componentDidMount () {
    const { store } = this.props
    this._unlisten = browserHistory.listen(location => {
      store.dispatch(setLocation(location))
      // FROM: https://github.com/reactjs/react-router/issues/2144#issuecomment-150939358
      // Use setTimeout to make sure this runs after React Router's own listener
      setTimeout(() => {
        // Keep default behavior of restoring scroll position when user:
        // - clicked back button
        // - clicked on a link that programmatically calls `history.goBack()`
        // - manually changed the URL in the address bar (here we might want
        // to scroll to top, but we can't differentiate it from the others)
        if (location.action === 'POP') {
          return
        }
        // In all other cases, scroll to top
        window.scrollTo(0, 0)
      })
    })

    // pre-load wp page data for important routes
    routes.childRoutes
      .filter(r => r.preloadWpDataClientSide)
      .forEach(({ wpPageId }) => {
        if (!store.getState().wpData.pages[wpPageId]) {
          getWpPageData(wpPageId).then(pageData =>
            store.dispatch(requestWpPageDataSuccess(pageData))
          )
        }
      })
  }
  componentWillUnmount () {
    if (typeof this._unlisten === 'function') {
      this._unlisten()
    }
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <Router history={browserHistory} children={routes} />
      </Provider>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./frontend/scripts/react/containers/Root.js